<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="point-terms-of-service">
      <Title jpn="Nutzungsbedingungen für Münzen" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Diese Nutzungsbedingungen (im Folgenden als „Coin-Nutzungsbedingungen“ bezeichnet) legen die Bedingungen für die Nutzung von „Coin“ (unten definiert) auf
              <a href="https://gtchaxonline.com/" target="_blank" >https://gtchaxonline.com/</a>
              (im Folgenden als „Dienst“ bezeichnet) fest, die von Xero Place Co., Ltd. (im Folgenden als „Unternehmen“ bezeichnet) bereitgestellt werden.
            </span>
            <span class="text">Bitte lesen Sie die Nutzungsbedingungen für Coins sorgfältig durch, bevor Sie über den Kauf von Coins nachdenken.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artikel 1 – Definition der Begriffe</span>
            <span class="text">Die Bedeutung der Begriffe in den folgenden Punkten dieser Bedingungen ist wie in jedem Punkt angegeben.</span>
            <span class="text">(1) „Dienstnutzungsvereinbarung“ bezeichnet einen Vertrag über die Nutzung des Dienstes.</span>
            <span class="text">(2) „Dienstnutzer“ ist eine Person, die mit unserem Unternehmen einen Dienstnutzungsvertrag abgeschlossen hat.</span>
            <span class="text">(3) „Kontoinformationen“ sind Informationen im Zusammenhang mit dem Dienstnutzer, die der Dienstnutzer beim Dienst registriert hat.</span>
            <span class="text">(4) „Coin“ bezeichnet eine Währung, die nur von unserem Unternehmen verwendet werden kann.</span>
            <span class="text">(5) „Verwendetes Guthaben“ ist das Guthaben an Münzen, das vom Dienstnutzer gehalten wird und zur Nutzung zur Verfügung steht.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artikel 2 – Münze</span>
            <span class="text">(1) Dienstnutzer können Münzen erwerben, die innerhalb des Dienstes verwendet werden können, und zwar auf die vom Unternehmen angegebene Weise und zu dem vom Unternehmen im Dienst angegebenen Preis. Darüber hinaus kann das Unternehmen Kaufeinheiten, Zahlungsmethoden, Nutzungszeiträume und andere Kaufbedingungen für den Kauf von Münzen für Servicenutzer festlegen. Die festgelegten Kaufbedingungen und der zu zahlende Betrag usw. werden innerhalb des Service oder der vom Unternehmen betriebenen Dienste veröffentlicht.</span>
            <span class="text">(2) Wenn ein Servicenutzer seine Absicht zum Ausdruck bringt, eine Münze auf die von der Gesellschaft vorgeschriebene Weise zu kaufen, kommt zwischen dem Servicenutzer und der Gesellschaft ein Vertrag über den Kauf der Münze zustande und der Gesamtbetrag für den Kauf wird festgelegt.</span>
            <span class="text">(3) Wenn der Dienstnutzer, der Coin kauft, minderjährig ist, muss der Dienstnutzer vor dem Kauf von Coin die Zustimmung eines Elternteils oder Erziehungsberechtigten einholen.</span>
            <span class="text">(4) Erwirbt ein Minderjähriger einen Coin, geht das Unternehmen davon aus, dass der Erziehungsberechtigte dem Erwerb des Coins zugestimmt hat.</span>
            <span class="text">(5) Der innerhalb des Dienstes angezeigte Nutzungssaldo des Dienstnutzers wird mit Kontoinformationen verknüpft und in den Telekommunikationsgeräten aufgezeichnet, die zur Bereitstellung des Dienstes und anderer vom Unternehmen betriebener Dienste verwendet werden.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artikel 3 – Verwendung von Münzen</span>
            <span class="text">(1) Für den Kauf unserer Produkte können Münzen verwendet werden.</span>
            <span class="text">(2) Servicenutzer können vom Unternehmen bereitgestellte Produkte im Rahmen ihres Coin-Guthabens erwerben.</span>
            <span class="text">(3) Wenn ein Servicenutzer Coin verwendet, um ein Produkt vom Unternehmen zu kaufen, wird der Preis des Produkts vom Coin-Guthaben abgezogen und der Betrag gilt als bezahlt.</span>
            <span class="text">Sofern nicht anders angegeben, werden Münzen, die das Unternehmen den Dienstnutzern im Rahmen des Dienstes kostenlos zur Verfügung stellt, bevorzugt verwendet.</span>
            <span class="text">(4) Dienstnutzer können ihr Münzguthaben innerhalb des Dienstes überprüfen. Darüber hinaus sind die Servicenutzer für die Verwaltung und Kontrolle der Zunahme und Abnahme der Coins verantwortlich.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artikel 4 – Umgang mit Münzen</span>
            <span class="text">(1) Das Unternehmen gewährt dem Benutzer Münzen gemäß der vom Unternehmen festgelegten Methode, wenn der Benutzer Münzen im Dienst kauft, wenn das Unternehmen eine Kampagne durchführt oder in anderen Fällen. Die Coin-Kaufeinheit, der Preis, die Gültigkeitsdauer und andere Bedingungen für die Gewährung von Coins werden vom Unternehmen festgelegt und im Service angezeigt.</span>
            <span class="text">(2) Die Gültigkeitsdauer des Coins beträgt 6 Monate ab Gewährung des Coins.</span>
            <span class="text">(3) Das Unternehmen erstattet vom Nutzer erworbene Coins nicht, es sei denn, dies ist gesetzlich vorgeschrieben. Im Falle der Rückerstattung von Münzen auf der Grundlage von Gesetzen und Vorschriften werden die Rückerstattungsmethode und -bedingungen in einer vom Unternehmen festgelegten Weise separat veröffentlicht.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artikel 5 – Verbot der Bargeldumrechnung usw.</span>
            <span class="text">In Bezug auf alle im Rahmen dieses Dienstes erworbenen Inhalte ist jegliche Übertragung, Weitergabe, Verleihung, Ausleihe usw. in Form des Gebens oder Empfangens von Geld oder anderen realen Gegenleistungen (einschließlich, aber nicht beschränkt auf den sogenannten RMT [Echtgeldhandel]), sei es direkt, durch Vermittlung Dritter, Internetauktion oder auf andere Weise, verboten.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artikel 6 – Übertragung von Münzen usw.</span>
            <span class="text">Servicenutzer dürfen Coins oder Produkte nicht an Dritte abtreten, verleihen, verschenken oder anderweitig übertragen, noch dürfen sie sie verpfänden oder auf andere Weise ein Sicherungsrecht festlegen.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artikel 7 – Aussetzung des Kaufs und der Verwendung von Münzen usw.</span>
            <span class="text">Wenn ein Dienstnutzer unter einen der folgenden Punkte fällt, kann das Unternehmen Maßnahmen gegen den Dienstnutzer ergreifen, die das Unternehmen für angemessen hält (einschließlich, aber nicht beschränkt auf die Aussetzung des Kaufs oder der Verwendung von Coin).</span>
            <span class="text">(1) Wenn Münzen oder Produkte auf illegale Weise erlangt oder verwendet werden</span>
            <span class="text">(2) Wenn der Dienstnutzer gegen diese Nutzungsbedingungen verstößt</span>
            <span class="text">(3) In anderen Fällen, in denen das Unternehmen feststellt, dass die Nutzung des Dienstes durch den Dienstnutzer unangemessen ist.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Gegründet am 28. Februar 2025</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_point_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.point-terms-of-service{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .point-terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
